import { BenchmarkType } from 'model/BenchmarkType';

export type BenchmarkData = {
  label: string;
  type: BenchmarkType;
  value?: number | null;
};

export type Benchmark = BenchmarkData | undefined | null;

export namespace Benchmark {
  export const isNotNone = (benchmark?: Benchmark): benchmark is BenchmarkData => {
    return !!benchmark && benchmark.type !== BenchmarkType.NONE;
  };

  export const isVsExternalBenchmark = (benchmark?: Benchmark): boolean => {
    return !!benchmark && benchmark.type === BenchmarkType.VS_EXTERNAL_BENCHMARK;
  };

  export const getShortBenchmarkLabel = (benchmark?: Benchmark) => {
    return (benchmark && benchmark.label && benchmark.label.replace('Vs', '')) || '';
  };
}
